import { Dispatch } from 'redux'

import ClientPassengerInterface from '../../interfaces/client/Passenger'
import ClientSSRInterface from '../../interfaces/client/SSR'

import addPassengerSSR from '../../actions/passengers/addPassengerSSR'

import generateUniqueId from '../../utils/generateUniqueId'

export default (dispatch: Dispatch) => (
  passengers: ClientPassengerInterface[]
) =>
  passengers
    .filter((passenger: ClientPassengerInterface) => passenger.ssrs.length)
    .forEach((passenger: ClientPassengerInterface) => {
      const { ssrs, id } = passenger

      ssrs.forEach((ssr: ClientSSRInterface) => {
        const uniqueId = `${ssr.id}-${generateUniqueId()}`
        const addPassengerSSROptions = {
          isConfirmed: true,
          isAbleToDelete: ssr.isAddedByTourOperator,
          note: ssr.note,
          ssrNumber: ssr.ssrNumber,
        }

        dispatch(addPassengerSSR(id, uniqueId, ssr.id, addPassengerSSROptions))
      })
    })
